import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import WelcomeCard from "../../components/WelcomeCard/WelcomeCard";
import {
  Box,
  Typography,
  TextField,
  MenuItem,
  Snackbar,
  Alert,
} from "@mui/material";
import Table, {
  type TableColumn,
} from "../../components/CommonTable/CommonTable";
import { useAppDispatch, useAppSelector } from "../../../Redux/Store/Hooks";
import { studyMaterialAddToCartCreate } from "../../../Redux/Slices/Booklet/Tutor/StudyMaterial/StudyMaterialAddToCartCreate";
import {
  ClassYeargroupRead,
  clearClassYeargroupRead,
} from "../../../Redux/Slices/Booklet/Tutor/ClassSelection/ClassYeargroup";
import { ClassSubjectRead } from "../../../Redux/Slices/Booklet/Tutor/ClassSelection/ClassSubject";
import { ClassDrive_fileRead } from "../../../Redux/Slices/Booklet/Tutor/ClassSelection/ClassDriveFile";
import { FileItem, Option, StudyMaterial } from "./IStudyMaterial";
import SearchBar from "../../components/search/Search";
import { clearAiDriveSearch } from "../../../Redux/Slices/Booklet/Tutor/AiSearch/AiSearch";
import { clearCentreMasterCreate } from "../../../Redux/Slices/Booklet/Admin/CentreMaster/CentreMasterCreate";
import ReportIcon from "@mui/icons-material/Report";
import { ClassCenterRead, clearClassCenterRead } from "../../../Redux/Slices/Booklet/Tutor/ClassSelection/ClassCenter";

interface SearchAPIResponse {
  found_items: {
    id: string;
    name: string;
    mime_type: string;
    drive_link: string;
    modified_time?: string;
    subject_id: number;
  }[];
  cached: boolean;
  cache_age: string;
  total_results: number;
  query: string;
}

// ---------- Helper Functions ----------
const formatRelativeDate = (dateString: string): string => {
  try {
    const date = new Date(dateString);
    const now = new Date();
    const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);

    if (diffInSeconds < 60) return "Just now";
    if (diffInSeconds < 3600) {
      const minutes = Math.floor(diffInSeconds / 60);
      return minutes === 1 ? "1 minute ago" : `${minutes} minutes ago`;
    }
    if (diffInSeconds < 86400) {
      const hours = Math.floor(diffInSeconds / 3600);
      return hours === 1 ? "1 hour ago" : `${hours} hours ago`;
    }
    if (diffInSeconds < 604800) {
      const days = Math.floor(diffInSeconds / 86400);
      return days === 1 ? "Yesterday" : `${days} days ago`;
    }
    if (diffInSeconds < 2592000) {
      const weeks = Math.floor(diffInSeconds / 604800);
      return weeks === 1 ? "1 week ago" : `${weeks} weeks ago`;
    }
    if (diffInSeconds < 31536000) {
      const months = Math.floor(diffInSeconds / 2592000);
      return months === 1 ? "1 month ago" : `${months} months ago`;
    }
    const years = Math.floor(diffInSeconds / 31536000);
    return years === 1 ? "1 year ago" : `${years} years ago`;
  } catch {
    return "Unknown";
  }
};

// ---------- Component ----------
const StudyMaterials = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const selectedData = location.state;

  console.log(selectedData, "selectedData");

  const [username, setUsername] = useState<string>("User");
  const [isLocked, setIsLocked] = useState(false);
  const [filters, setFilters] = useState({
    center:"",
    yearOfGroup: "",
    subject: "",
    topic: "",
  });
  const [tableData, setTableData] = useState<StudyMaterial[]>([]);

  const { data: yearGroupData, isLoading: yearGroupLoading } = useAppSelector(
    (state) => state.ClassYeargroupRead
  );
    const { data: CenterData, isLoading: CenterLoading } = useAppSelector(
    (state) => state.ClassCenterRead
  );
  const { data: subjectData, isLoading: subjectLoading } = useAppSelector(
    (state) => state.ClassSubjectRead
  );
  const { data: driveFileData, isLoading: driveFileLoading } = useAppSelector(
    (state) => state.ClassDrive_fileRead
  );

  const { data: SearchData, isLoading: searchDataLoading } = useAppSelector(
    (state) => state.AiDriveSearch
  ) as { data?: SearchAPIResponse; isLoading: boolean };

  const yearGroups = yearGroupData?.data ?? [];
  const Center = CenterData?.data ?? [];
  const subjects = subjectData?.data ?? [];
  const driveData = driveFileData?.data ?? [];

  console.log(CenterData,"CenterData")

  const clearAllFilters = () => {
    if (!selectedData) {
      setFilters((prev) => ({ ...prev, subject: "", topic: "" }));
    } else {
      setFilters((prev) => ({ ...prev, topic: "" }));
    }
    setTableData([]);
    dispatch(clearAiDriveSearch());
  };
  const [snackbar, setSnackbar] = useState<{
    open: boolean;
    message: string;
    severity: "success" | "error";
    key?: number;
  }>({ open: false, message: "", severity: "success" });

  const showSnackbar = (
    message: string,
    severity: "success" | "error" = "success"
  ) => {
    setSnackbar({
      open: true,
      message,
      severity,
      key: new Date().getTime(), // 👈 unique key
    });
  };
  // ---------- Effects ----------
  useEffect(() => {
    const storedUsername = sessionStorage.getItem("username");
    if (storedUsername) {
      const formatted =
        storedUsername.charAt(0).toUpperCase() +
        storedUsername.slice(1).toLowerCase();
      setUsername(formatted);
    }
  }, []);

  useEffect(() => {
    dispatch(ClassYeargroupRead());
    dispatch(ClassCenterRead());
  }, [dispatch]);

  useEffect(() => {
    dispatch(clearAiDriveSearch());
    dispatch(clearClassYeargroupRead());
    dispatch(clearClassCenterRead());
  }, [dispatch]);

  console.log(SearchData, "SearchData");
  useEffect(() => {
    if (
      (!SearchData?.found_items || SearchData.found_items.length === 0) &&
      !filters.topic
    ) {
      setTableData([]);
    }
  }, [SearchData, filters.topic]);

  useEffect(() => {
    if (filters.yearOfGroup) {
      dispatch(ClassSubjectRead({ item_id: filters.yearOfGroup }));
      if (!selectedData) {
        setFilters((prev) => ({ ...prev, topic: "" }));
      }
    }
  }, [filters.yearOfGroup, dispatch]);


  useEffect(() => {
    if (filters.subject) {
      dispatch(ClassDrive_fileRead({ item_id: filters.subject }));
      if (!selectedData) {
        setFilters((prev) => ({ ...prev, topic: "" }));
      }
    }
  }, [filters.subject, dispatch]);

  const extractAllFiles = (items: FileItem[]): FileItem[] => {
    let files: FileItem[] = [];
    for (const item of items) {
      if (item.type === "file") {
        files.push(item);
      } else if (item.children && item.children.length > 0) {
        files = files.concat(extractAllFiles(item.children));
      }
    }
    return files;
  };

  useEffect(() => {
    if (filters.topic) {
      const selectedTopic = driveData.find((t: any) => t.id === filters.topic);

      if (selectedTopic) {
        // Include top-level files in addition to children
        const topLevelFiles =
          selectedTopic.type === "file" ? [selectedTopic] : [];
        const allFiles = extractAllFiles(selectedTopic.children || []);
        const files = [...topLevelFiles, ...allFiles].map((item: FileItem) => ({
          id: item.id,
          name: item.name,
          mimeType: item.mimeType,
          webViewLink: item.webViewLink,
          modifiedTime: item.modified_time,
          lastUpdate: formatRelativeDate(item.modified_time),
          editable: true,
          subject_id: item.subject_id,
          quantity: 0,
          print: "Take Print",
          status: false,
        }));

        setTableData(files);
      } else {
        setTableData([]);
      }
    }
  }, [filters.topic, driveData]);

  useEffect(() => {
    if (SearchData?.found_items && SearchData.found_items.length > 0) {
      const files = SearchData.found_items.map((item: any) => ({
        id: item.id,
        name: item.name,
        mimeType: item.mime_type,
        webViewLink: item.drive_link,
        modifiedTime: item.modified_time || "", // if available
        lastUpdate: formatRelativeDate(
          item.modified_time || new Date().toISOString()
        ),
        editable: true,
        quantity: 0,
        subject_id: item.subject_id,
        print: "Take Print",
        status: false,
      }));
      setTableData(files);
    } else if (!filters.topic) {
      setTableData([]);
    }
  }, [SearchData]);

  // ---------- Options ----------
  const yearOptions = yearGroups.map((y: any) => ({
    id: y.id,
    label: y.yeargroup.name,
  }));
    const centerOptions = Center.map((c: any) => ({
    id: c.center_id,
    label: c.center_name,
  }));
  const subjectOptions = subjects.map((s: any) => ({
    id: s.id,
    label: s.name,
  }));
  const topicOptions = driveData.map((t: any) => ({ id: t.id, label: t.name }));

  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleQuantityChange = (
    row: StudyMaterial,
    _index: number,
    newQuantity: number
  ) => {
    setTableData((prev) =>
      prev.map((item) =>
        item.id === row.id
          ? { ...item, quantity: newQuantity, status: row.status }
          : item
      )
    );

    const payload = {
      cart_id: "0",
      pdf_id: row.id,
      tutor_id: 0,
      quantity: newQuantity,
      status: row.status,
      center_id: filters.center || selectedData.center_id,
      subject_id: filters.subject || row.subject_id,
      topic_id:filters.topic,
    };
    dispatch(studyMaterialAddToCartCreate(payload));

    setSnackbar({
      open: true,
      message: `Item "${row.name}" ${
        newQuantity > 0 ? "added to" : "removed from"
      } cart`,
      severity: "success",
      key: new Date().getTime(),
    });
  };

  const columns: TableColumn<StudyMaterial>[] = [
    {
      key: "name",
      title: "File Name",
      render: (value) => (
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          {String(value)}
        </Typography>
      ),
    },
    { key: "lastUpdate", title: "Last Updated", sortable: true },
    { key: "preview", title: "Preview" },
    { key: "Add to Cart", title: "Add to Cart" },
  ];

  useEffect(() => {
    if (selectedData) {
      setFilters({
        yearOfGroup: selectedData.yeargroup_id,
        center:selectedData.center_id, // use ID
        subject: selectedData.subject_id, // use ID
        topic: "",
      });
      setIsLocked(true);
    }
  }, [selectedData]);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "15px" }}>
      {/* Welcome Section */}
      <WelcomeCard
        userName={username}
        title="Welcome to Everest Tutoring"
        description="Tutors can quickly download well-structured notes, worksheets, and exam-ready content to support their students. Everything you need to teach effectively—organized and ready to use."
      />
      <Box
        sx={{
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          p: 3,
          backgroundColor: "#fff",
        }}
      >
        {/* {!selectedData ? (
          <Box
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: "8px",
              p: 3,
              backgroundColor: "#fff",
              textAlign: "center",
            }}
          >
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
              Please select class selection before selecting study material
            </Typography>

            <button
              onClick={() => navigate("/class_selection")}
              style={{
                padding: "10px 20px",
                borderRadius: "8px",
                backgroundColor: "#009DFF",
                color: "#fff",
                border: "none",
                cursor: "pointer",
                fontSize: "15px",
                fontWeight: "500",
              }}
            >
              Go to Class Selection
            </button>
          </Box>
        ) : (
          <>
            ORIGINAL SearchBar + Filters UI HERE */}

            <SearchBar />

            <Box
              sx={{
                border: "1px solid #e0e0e0",
                borderRadius: "8px",
                p: 3,
                mt: 2,
                backgroundColor: "#fff",
              }}
            >
              <Typography variant="h6" sx={{ mb: 1 }}>
                Study Material
              </Typography>

              {!filters.topic && (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 1,
                    mb: 3,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <ReportIcon sx={{ color: "#009FDD", fontSize: 22 }} />
                  </Box>

                  <Typography
                    sx={{
                      textAlign: "center",
                      color: "#009FDD",
                      fontSize: "14px",
                      fontWeight: 400,
                    }}
                  >
                    Please select a topic to view and add study materials
                  </Typography>
                </Box>
              )}

              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "repeat(4, 1fr)",
                  gap: 2,
                }}
              >
                <TextField
                  select
                  label="Center"
                  name="center"
                  value={filters.center}
                  onChange={handleFilterChange}
                  size="small"
                >
                  {CenterLoading ? (
                    <MenuItem disabled>Loading...</MenuItem>
                  ) : centerOptions.length === 0 ? (
                    <MenuItem disabled>No data available</MenuItem>
                  ) : (
                    centerOptions.map((center: Option) => (
                      <MenuItem key={center.id} value={center.id}>
                        {center.label}
                      </MenuItem>
                    ))
                  )}
                  {isLocked &&
                    filters.center &&
                    !centerOptions.find((c:any) => c.id === filters.center) && (
                      <MenuItem
                        value={filters.center}
                        style={{ display: "none" }}
                      >
                        {selectedData?.center_name || "Selected Year"}
                      </MenuItem>
                    )}
                </TextField>


                <TextField
                  select
                  label="Year of Group"
                  name="yearOfGroup"
                  value={filters.yearOfGroup}
                  onChange={handleFilterChange}
                  size="small"
                >
                  {yearGroupLoading ? (
                    <MenuItem disabled>Loading...</MenuItem>
                  ) : yearOptions.length === 0 ? (
                    <MenuItem disabled>No data available</MenuItem>
                  ) : (
                    yearOptions.map((year: Option) => (
                      <MenuItem key={year.id} value={year.id}>
                        {year.label}
                      </MenuItem>
                    ))
                  )}
                  {isLocked &&
                    filters.yearOfGroup &&
                    !yearOptions.find((y:any) => y.id === filters.yearOfGroup) && (
                      <MenuItem
                        value={filters.yearOfGroup}
                        style={{ display: "none" }}
                      >
                        {selectedData?.yeargroup_name || "Selected Year"}
                      </MenuItem>
                    )}
                </TextField>
                <TextField
                  select
                  label="Subject"
                  name="subject"
                  value={filters.subject}
                  onChange={handleFilterChange}
                  size="small"
                 
                >
                  {subjectLoading ? (
                    <MenuItem disabled>Loading...</MenuItem>
                  ) : subjectOptions.length === 0 ? (
                    <MenuItem disabled>No data available</MenuItem>
                  ) : (
                    subjectOptions.map((sub: Option) => (
                      <MenuItem key={sub.id} value={sub.id}>
                        {sub.label}
                      </MenuItem>
                    ))
                  )}
                     {isLocked &&
                    filters.subject &&
                    !yearOptions.find((y:any) => y.id === filters.subject) && (
                      <MenuItem
                        value={filters.subject}
                        style={{ display: "none" }}
                      >
                        {selectedData?.subject_name || "Selected subject"}
                      </MenuItem>
                    )}
                </TextField>
                <TextField
                  select
                  label="Topic"
                  name="topic"
                  value={filters.topic}
                  onChange={handleFilterChange}
                  size="small"
                  disabled={!filters.subject}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: !filters.topic ? "#009DFF" : undefined,
                      },
                      "&:hover fieldset": {
                        borderColor: !filters.topic ? "#007ACC" : undefined,
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#009DFF",
                      },
                    },
                  }}
                >
                  {driveFileLoading ? (
                    <MenuItem disabled>Loading...</MenuItem>
                  ) : topicOptions.length === 0 ? (
                    <MenuItem disabled>No data available</MenuItem>
                  ) : (
                    topicOptions.map((top: Option) => (
                      <MenuItem key={top.id} value={top.id}>
                        {top.label}
                      </MenuItem>
                    ))
                  )}
                </TextField>
              </Box>
            </Box>
          {/* </> */}
        {/* )} */}
      </Box>

      {/* Table */}
      <Box
        sx={{
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          p: 3,
          backgroundColor: "#fff",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Box>
            <Typography variant="h6" sx={{ mb: 2 }}>
              Study Material Details
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              mb: 3,
            }}
          >
            {/* Clear Filters */}
            <button
              onClick={clearAllFilters}
              style={{
                padding: "8px 16px",
                border: "1px solid #009DFF",
                backgroundColor: "white",
                color: "#009DFF",
                borderRadius: "20px",
                cursor: "pointer",
                fontSize: "14px",
                fontWeight: "500",
              }}
            >
              Clear all
            </button>

            {/* Go to Cart */}
            <button
              onClick={() => navigate("/study_materials/cart")}
              style={{
                padding: "8px 16px",
                border: "1px solid #009DFF",
                backgroundColor: "white",
                color: "#009DFF",
                borderRadius: "20px",
                textTransform: "none",
                cursor: "pointer",
                fontSize: "14px",
                fontWeight: "500",
              }}
            >
              Go to cart
            </button>
          </Box>
        </Box>

        <Table<StudyMaterial>
          columns={columns}
          loading={searchDataLoading}
          data={tableData}
          onQuantityChange={handleQuantityChange}
          getPreviewId={(row) => row.id}
        />
      </Box>
      <Snackbar
        key={snackbar.key} // 👈 Important
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%", minHeight: "50px" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default StudyMaterials;
